// v2/components/SiparisGonderimi.js — siparis gonderilirken ekran ortusu + basari penceresi
// Gonderim surerken sayfa tiklanamaz ve sayfadan cikilmak istenirse tarayici uyarir;
// boylece musteri "takildi" sanip tekrar basmaz.
import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Loader2, CheckCircle2, X } from 'lucide-react';
import styles from './SiparisGonderimi.module.css';

export default function SiparisGonderimi({
  gonderiliyor = false, sonuc = null, onKapat = () => {}, siparislerYolu = '/v2/orders',
}) {
  const btnRef = useRef(null);

  // gonderim surerken sayfadan cikis uyarisi
  useEffect(() => {
    if (!gonderiliyor) return undefined;
    const uyar = (e) => { e.preventDefault(); e.returnValue = ''; return ''; };
    window.addEventListener('beforeunload', uyar);
    return () => window.removeEventListener('beforeunload', uyar);
  }, [gonderiliyor]);

  // basari penceresi: odak + Esc ile kapat
  useEffect(() => {
    if (!sonuc) return undefined;
    if (btnRef.current) btnRef.current.focus();
    const esc = (e) => { if (e.key === 'Escape') onKapat(); };
    document.addEventListener('keydown', esc);
    return () => document.removeEventListener('keydown', esc);
  }, [sonuc, onKapat]);

  if (gonderiliyor) {
    return (
      <div className={styles.overlay} role="alertdialog" aria-live="assertive" aria-busy="true"
           aria-label="Sipariş gönderiliyor">
        <div className={styles.box}>
          <Loader2 size={32} className={styles.spin} />
          <b className={styles.title}>Siparişiniz gönderiliyor</b>
          <span className={styles.text}>Lütfen bekleyin, sayfayı kapatmayın.</span>
        </div>
      </div>
    );
  }

  if (!sonuc) return null;
  const nolar = sonuc.nolar || [];

  return (
    <div className={styles.overlay} role="dialog" aria-modal="true" aria-label="Siparişiniz alındı">
      <div className={styles.backdrop} onClick={onKapat} aria-hidden="true" />
      <div className={`${styles.box} ${styles.boxOk}`}>
        <button type="button" className={styles.close} onClick={onKapat} aria-label="Kapat">
          <X size={16} />
        </button>
        <CheckCircle2 size={44} className={styles.okIcon} />
        <b className={styles.title}>Siparişiniz alındı</b>
        <span className={styles.text}>{sonuc.kalem} ürün için siparişiniz oluşturuldu.</span>
        {nolar.length > 0 && (
          <span className={styles.nos}>
            Sipariş No: <strong>{nolar.slice(0, 5).join(', ')}{nolar.length > 5 ? ` +${nolar.length - 5}` : ''}</strong>
          </span>
        )}
        <div className={styles.actions}>
          <button ref={btnRef} type="button" className={styles.ghost} onClick={onKapat}>Sepete Dön</button>
          <Link to={siparislerYolu} className={styles.main} onClick={onKapat}>Siparişlerime Git</Link>
        </div>
      </div>
    </div>
  );
}
